import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PROPERTY_ENRICHMENT_ACTION_TYPE } from '../actions';

const initialState = {
  data: null,
  isLoading: false,
};

const propertyEnrichmentReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case PROPERTY_ENRICHMENT_ACTION_TYPE.FETCH_PROPERTY_ENRICHMENT_START:
        draft.isLoading = true;
        break;

      case PROPERTY_ENRICHMENT_ACTION_TYPE.GET_PROPERTY_ENRICHMENT:
        draft.data = payload;
        draft.isLoading = false;
        break;

      case PROPERTY_ENRICHMENT_ACTION_TYPE.FETCH_PROPERTY_ENRICHMENT_FAILED:
        draft.isLoading = false;
        break;

      case PROPERTY_ENRICHMENT_ACTION_TYPE.RESET_PROPERTY_ENRICHMENT:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default propertyEnrichmentReducer;
